<mat-form-field
  class="field-filtre field-filtre-text"
  [floatLabel]="floatLabel"
  >
  <mat-label>{{ label }}</mat-label>

  <input
    #inputElement
    type="text"
    matInput
    [formControl]="control"
    name="search"
    [matAutocomplete]="autocomplete"
    [placeholder]="placeholder"
    [attr.aria-label]="ariaLabel || label"
    [disabled]="disabled"
    (blur)="onInputBlur()"
    />

    @if (showClearButton()) {
      <button
        type="button"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="onClear($event)"
        [disabled]="disabled"
        >
        <mat-icon>close</mat-icon>
      </button>
    }

    <mat-autocomplete
      #autocomplete="matAutocomplete"
      hideSingleSelectionIndicator
      [displayWith]="displayFn"
      class="autocomplete-virtual-scroll"
      (opened)="onAutocompleteOpened()"
      (closed)="onAutocompleteClosed()"
      (optionSelected)="onOptionSelected()"
      >
      <cdk-virtual-scroll-viewport
        #virtualScrollViewport
        class="virtual-scroll-viewport"
        [itemSize]="effectiveConfig().itemSize"
        [style.height]="viewportHeight()"
        >
        @if (filteredData().length === 0 && searchText()) {
          <mat-option disabled>
            <em>Aucun résultat trouvé</em>
          </mat-option>
        }
        <mat-option
          *cdkVirtualFor="let item of filteredData(); trackBy: trackByFn"
          [value]="item"
          [style.min-height]="optionMinHeight()"
          [style.line-height]="optionLineHeight()"
          >
          {{ effectiveConfig().displayFn(item) }}
        </mat-option>
      </cdk-virtual-scroll-viewport>

      <!-- Empty State -->

    </mat-autocomplete>
  </mat-form-field>

